import { COMPONENT_VALUE_TYPES as types } from 'shared/constants';

const propsSchema = [
  {
    key: 'title',
    label: 'Title',
    type: types.TEXT,
  },
  {
    key: 'btn_text',
    label: 'Button Text',
    type: types.TEXT
  },
  {
    key: 'downloadBioText',
    label: 'Download Bio Text',
    type: types.TEXT
  },
  {
    key: 'bio',
    label: 'Biography',
    type: types.ARRAY,
    children: [
      {
        key: 'name',
        label: 'Name',
        type: types.TEXT
      },
      {
        key: 'img_url',
        label: 'Portrait Image URL',
        type: types.TEXT
      },
      {
        key: 'title',
        label: 'Position Title',
        type: types.TEXT
      },
      {
        key: 'desc',
        label: 'Bio Description',
        type: types.TEXTAREA
      },
      {
        key: 'quote',
        label: 'Quote',
        type: types.TEXTAREA
      },
      {
        key: 'download_url',
        label: 'Download URL',
        type: types.TEXT
      }
    ]
  },
  {
    key: 'socialLinks',
    label: 'Social Links',
    type: types.ARRAY,
    option: false,
    children: [
      {
        key: 'url',
        label: 'URL',
        type: types.TEXT
      },
      {
        key: 'icon',
        label: 'Icon',
        type: types.ICON
      }
    ]
  }
];

const defaultProps = {
  title: 'Executive Team',
  btn_text: 'Read Bio',
  downloadBioText: 'Download Full Bio',
  bio: [
    {
      name: 'Stefan Krause',
      img_url: 'https://genesis-cdn.ff.com/our_company/02_execs/stefan-karuse-chief-operating-officer-chief-financial-officer-headshot.jpg',
      title: 'Chief Operating Officer and Global Chief Financial Officer',
      desc: 'Stefan Krause serves as the Global Chief Financial Officer (CFO), leading corporate finance, investor relations, and capital management efforts for Faraday Future. With nearly 30 years of executive experience, Krause’s well-rounded expertise spans the worlds of finance and automotive. Prior to joining FF, Krause served as CFO and Board Member for Deutsche Bank, leading the company’s strategic growth, operational development, and financial reporting. Between 1987 and 2008, Krause worked with BMW Group in both Europe and the US, holding key leadership roles including BMW Global CFO and Head of Sales & Marketing, President and CEO of BMW Financial Services, and Chief Executive of Rolls-Royce, among others. Krause was also instrumental in developing the strategy behind BMW’s iCar production vehicles, including the i3 and i8.',
      quote: '“At Faraday Future, I have the unique opportunity to lead an organization focused on the future of mobility. I’m excited to join this team of dedicated, highly talented individuals, and to establish critical investor relationships that will help grow the company as Faraday Future establishes a strong presence in the global technology marketplace.”',
      download_url: 'https://genesis-cdn.ff.com/our_company/02_execs/FF_Bio_Stefan_EN.pdf'
    },
    {
      name: 'Ulrich Kranz',
      img_url: 'https://genesis-cdn.ff.com/our_company/02_execs/ulrich-kranz-chief-technology-officer.jpg',
      title: 'Chief Technology Officer',
      desc: 'Ulrich Kranz (“Ulli”) serves as the Chief Technology Officer, in charge of engineering and technology research and development, purchasing, and manufacturing process improvements to bring FF products to market. Kranz is a veteran of the automotive industry with three decades of engineering, development, sustainability, and management experience at BMW. Before arriving at Faraday Future, Kranz was a Sr. Vice President at BMW, where he spent the majority of his career. He established BMW’s first manufacturing efforts in the United States and played a critical role in the development of the i sub-brand. Kranz also led the successful launch of multiple vehicle lines, including i8, i3, Z3, and X5, and reintroduced MINI as a global brand. Kranz brings critical leadership to Faraday Future, and will lead all aspects of future product introduction, including new models, integrated technologies, and architecture improvements.',
      quote: '“I am deeply impressed by the core values at Faraday Future that made my joining an easy decision. FF has a broad spectrum of talent working hard to launch revolutionary products like FF 91. What FF has been able to accomplish in three short years is extremely impressive, and I look forward to leading the company’s efforts to get FF 91 on the road, and beyond.”',
      download_url: 'https://genesis-cdn.ff.com/our_company/02_execs/FF_Bio_Ulli_EN.pdf'
    },
    {
      name: 'Nick Sampson',
      img_url: 'https://genesis-cdn.ff.com/our_company/02_execs/nick-sampson-senior-vice-president-research-and-development.jpg',
      title: 'SVP of R&D and Engineering',
      desc: 'Nick Sampson was one of FF’s originators, and acts as the SVP of R&D and Product Development. Sampson brings 35 years of knowledge in lean vehicle systems, adaptive chassis, automotive safety, and modular systems to our company. Prior to joining FF, Sampson was the Director of Vehicle and Chassis Engineering at Tesla Motors. There, he created the complete concept for the vehicle architecture of the Tesla Model S and led the engineering team behind the Tesla Model X. Earlier at Lotus, Sampson was Chief Engineer and Program Director, leading vehicle programs and multi-disciplinary teams of up to 300 engineers to develop new adaptable platforms and implement long-term product strategies. During his 16 years at Jaguar, Sampson served as a key member of the Product Development Management Team where he supervised the development of the XJ6 sedan and XK8 sports car. He went on to design, engineer, and manage the production of winning race vehicles in the prestigious British Touring Car Championship while at Race Tech.',
      quote: '“What we’re making goes beyond performance. It doesn’t merely drive well – it evolves the experience of driving altogether.”',
      download_url: 'https://genesis-cdn.ff.com/our_company/02_execs/FF_Nick_Sampson_EN.pdf'
    },
    {
      name: 'Richard Kim',
      img_url: 'https://genesis-cdn.ff.com/our_company/02_execs/richard-kim-vice-president-of-design.jpg',
      title: 'VP of Design',
      desc: 'Richard Kim serves as the Head of Design, overseeing all aspects of design for FF products and brand. Prior to joining FF, Kim managed the design team for Special Programs & Group Design: Audi, Bentley, Porsche at the VW Group Design Center California. In 2008, Kim was one of the lead designers and a founding member of the BMW i team. There, he designed the visionary BMW i3 the i8 concepts, as well as the i8 Spyder. Beyond his work in the BMW Group, Kim has worked on private jet interiors for Embraer and luxury yachts for Intermarine under Designworks USA, a subsidiary of BMW. Kim started his career as a designer with Audi VW Group’s Design Center Europe in Barcelona. He still serves as a faculty member at the Art Center College of Design, as he has since 2007.',
      quote: '“The only ‘old school’ or traditional thing we’re doing here is working hard – putting in a lot of hours.”',
      download_url: 'https://genesis-cdn.ff.com/our_company/02_execs/FF_Richard_Kim_EN.pdf'
    },
    {
      name: 'Dag Reckhorn',
      img_url: 'https://genesis-cdn.ff.com/our_company/02_execs/dag-reckhorn-senior-vice-president-global-manufacturing.jpg',
      title: 'VP of Global Manufacturing',
      desc: 'Dag Reckhorn is responsible for developing FF’s global manufacturing strategy and overseeing the execution of all of the company’s manufacturing plans. In 2016, Reckhorn and his team will launch the construction process of FF’s first manufacturing facility – a $1 billion Nevada production plant that will create more than 4,500 jobs. Prior to joining FF, Reckhorn was the VP of Operations for Webasto Roof Systems, where he simultaneously oversaw four production plants and managed a team of more than 1,000 employees. At Tesla Motors, Reckhorn built up the vehicle manufacturing team and acquired all necessary equipment to initiate the first year of manufacturing for the Tesla Model S. After 16 years at German Coachbuilder Karmann, Reckhorn was appointed CEO of toolmaking and stamping supplier LSP Automotive – which he saved from the brink of bankruptcy and ensured its future success and security.',
      quote: '“Were developing something impactful – and we’re having a great time doing it. The excitement and energy here is tangible.”',
      download_url: 'https://genesis-cdn.ff.com/our_company/02_execs/FF_Dag_Reckhorn_EN.pdf'
    },
    {
      name: 'Peter Savagian',
      img_url: 'https://genesis-cdn.ff.com/our_company/02_execs/peter-savagian-vice-president-propulsion.jpg',
      title: 'VP of Propulsion Engineering',
      desc: 'Peter Savagian brings 25 years of experience in the EV industry to Faraday Future, where he will oversee all aspects of powertrain and battery design. As VP of Propulsion Engineering, he will head the development of FF’s propulsion systems – including energy storage, powertrain design, system controls, testing, and validation. Savagian comes to FF from General Motors, where he most recently served as General Director of Electric Drive Systems & New Product Development. In this role, he oversaw propulsion systems for a number of iconic electric cars, including the Chevy Volt and Chevy Bolt. During this time, he also directed the company’s EV manufacturing, IP, and supply chain management. Earlier, Savagian served GM as Propulsion Chief Engineer, where he developed and designed the electric drive systems underpinning GM’s EV1 – the renowned first mass-produced, purpose-built electric car from a major automaker. Across his career, Savagian has produced over 35 patents and 12 technical publications centered around vehicle electrification.',
      quote: '“Electric vehicles are my passion…my life’s work. It’s thrilling to help power this industry’s next big leap.”',
      download_url: 'https://genesis-cdn.ff.com/our_company/02_execs/FF_Peter_Savagian_EN.pdf'
    },
  ],
  socialLinks: [
    { url: 'https://linkedin.com', icon: 'ff-icon-social-linkedin' },
    { url: 'https://youtube.com', icon: 'ff-icon-social-youtube' },
    { url: 'https://twitter.com', icon: 'ff-icon-social-twitter' },
    { url: 'https://facebook.com', icon: 'ff-icon-social-facebook' },
    { url: 'https://instagram.com', icon: 'ff-icon-social-instagram' }
  ]
};

export default {
  title: 'Bio Overlay',
  id: 'BioOverlay',
  propsSchema,
  defaultProps
};
